import {useState , useEffect} from "react";
import {MENU_API} from "../utils/constants";


const useRestaurantMenu = (resId) =>{

    const [resInfo, setResInfo] = useState(null);

    useEffect(()=>{
        fetchData();
    },[]);


     //Using edu cors
     const ApiKey = '4e7a00598aebdb3d';
     const EDUCORS_URL = 'https://educorssolver.host/api/getData';
     // Target URL from you want to fetch data m ,ex-github api
     const Target = MENU_API + resId;
 

    const fetchData = async () => {
        const data = await fetch(
            `${EDUCORS_URL}?ApiKey=${ApiKey}&Target=${encodeURIComponent(Target)}`);
        const json = await data.json();
        setResInfo(json.data);
    }
    return resInfo;
};

export default useRestaurantMenu;


